import { render, staticRenderFns } from "./EditMetadataModal.vue?vue&type=template&id=0f3c844a&scoped=true"
import script from "./EditMetadataModal.vue?vue&type=script&lang=ts"
export * from "./EditMetadataModal.vue?vue&type=script&lang=ts"
import style0 from "./EditMetadataModal.vue?vue&type=style&index=0&id=0f3c844a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3c844a",
  null
  
)

export default component.exports